import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'tcs-pubnub-details',
  templateUrl: './pubnub-details.component.html',
  styleUrls: ['./pubnub-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PubnubDetailsComponent implements OnInit {
  constructor() {}

  public ngOnInit() {}
}
